var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-col',{staticClass:"text-center text-caption",attrs:{"cols":"12"}},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Upstate Coin & Gold. All rights reserved - PlatformGold® v"+_vm._s(_vm.version)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }